import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import Landing from "@/pages/Landing";
import Resources from "@/pages/Resources";
import Article from "@/pages/Article";
import Admin from "@/pages/Admin";
import ServiceDetail from "@/pages/ServiceDetail";
import Careers from "@/pages/Careers";

function App() {
  useLenis();
  return (
    <div className="App bg-mm-base min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/:slug" element={<Article />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/admin" element={<Admin />} />
          {/* Catch-all: any unknown route (including old WordPress URLs
              like /about/, /blog/, /contact/, /wp-admin, /wp-login.php,
              /category/*, /tag/*, /author/*, /feed/, /?p=*, dated archives, etc.)
              redirects to the homepage. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: { background: "#111613", border: "1px solid rgba(0,177,64,0.25)", color: "#fff" },
        }}
      />
    </div>
  );
}

export default App;
